import React, { useState } from "react";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";
import ServiceButton from "../../../common/ServiceButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import print1 from "../../../../assets/images/serviceImages/print1.webp";
import print2 from "../../../../assets/images/serviceImages/print2.webp";
import print3 from "../../../../assets/images/serviceImages/print3.webp";
import print4 from "../../../../assets/images/serviceImages/print4.webp";
import print5 from "../../../../assets/images/serviceImages/print5.webp";
import print6 from "../../../../assets/images/serviceImages/print6.webp";

type ButtonType = "Print & Merchandise";

const PrintAndMerchWork = () => {
  const [selectedButton, setSelectedButton] = useState<ButtonType>(
    "Print & Merchandise"
  );

  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <div className="flex justify-center gap-10 mb-5 sm:mb-10">
            <ServiceButton
              className={`${
                selectedButton === "Print & Merchandise" ? "!card-gradient" : ""
              } text-white`}
              onClick={() => setSelectedButton("Print & Merchandise")}
            >
              Print & Merchandise
            </ServiceButton>
          </div>
          <div>
            {selectedButton === "Print & Merchandise" && (
              <div className="text-white">
                <Swiper
                  modules={[Navigation, Pagination, Autoplay]}
                  className="flex justify-center items-center"
                  pagination={{
                    type: "bullets",
                    el: ".pagination-progress",
                    clickable: true,
                  }}
                  autoplay={true}
                  spaceBetween={20}
                  slidesPerView={1}
                  navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                  }}
                  loop
                >
                  <SwiperSlide className="rounded-[16px]">
                    <>
                      <div className="hidden lg:grid lg:grid-cols-4 gap-10">
                        <img
                          src={print1}
                          alt=""
                          className="rounded-[30px] w-full lg:row-span-2"
                        />
                        <img
                          src={print2}
                          alt=""
                          className="rounded-[30px] w-full"
                        />
                        <img
                          src={print3}
                          alt=""
                          className="rounded-[30px] w-full"
                        />
                        <img
                          src={print4}
                          alt=""
                          className="rounded-[30px] w-full lg:row-span-2"
                        />
                        <img
                          src={print5}
                          alt=""
                          className="rounded-[30px] w-full"
                        />
                        <img
                          src={print6}
                          alt=""
                          className="rounded-[30px] w-full"
                        />
                      </div>
                      <div className="lg:hidden">
                        <Swiper
                          modules={[Navigation, Pagination, Autoplay]}
                          className="flex justify-center items-center"
                          pagination={{
                            type: "bullets",
                            el: ".pagination-progress",
                            clickable: true,
                          }}
                          autoplay={true}
                          spaceBetween={20}
                          slidesPerView={1}
                          navigation={{
                            nextEl: ".swiper-button-next",
                            prevEl: ".swiper-button-prev",
                          }}
                          loop
                        >
                          <SwiperSlide>
                            <img
                              src={print1}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print2}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print3}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print4}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print5}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                          <SwiperSlide>
                            <img
                              src={print6}
                              className="rounded-[30px] h-[250px] object-cover w-full"
                              alt=""
                            />
                          </SwiperSlide>
                        </Swiper>
                      </div>
                    </>
                  </SwiperSlide>
                </Swiper>
              </div>
            )}
          </div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default PrintAndMerchWork;
